import React from "react";
import { makeStyles } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import { lightTheme } from "../../theme";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: lightTheme.palette.background.default,
    color: lightTheme.palette.text.primary,
  },
}));
export default function LightSection({
  children,
  className,
  noParent,
  component: Component = "div",
}) {
  const classes = useStyles();
  return (
    <ThemeProvider theme={lightTheme}>
      {noParent ? (
        children
      ) : (
        <Component className={`${classes.root} ${className || ""}`}>
          {children}
        </Component>
      )}
    </ThemeProvider>
  );
}
